export const REF_NAME = 'TOPMANAGER';
export const REF_PATH = 'topmanager';
export const NAME = 'Top managers';
